import { PayloadAction } from "@reduxjs/toolkit";
import { put, select, StrictEffect, takeLatest } from "redux-saga/effects";

import { DataType } from "@/jenesys-types/data/enums";
import { Transaction } from "@/jenesys-types/jenesys-entities/config";

import { dataUpdated, selectById } from "@/store/data/data";

/**
 * Saga that listens for transaction update success actions and automatically
 * updates the status from COMPLETED to REVIEWED in the local store.
 * (Optimistic frontend-only update, mirroring backend functionality)
 */
function* updateStatusOnSave(
  action: PayloadAction<{
    dataType: DataType;
    id: string;
    item: any;
  }>
): Generator<StrictEffect, void, any> {
  const { dataType, id } = action.payload;
  if (dataType !== DataType.Transaction) {
    return;
  }

  const currentTransaction: Transaction | undefined = yield select(
    selectById(DataType.Transaction, id)
  );
  if (currentTransaction && currentTransaction.status === "COMPLETED") {
    const updatedTransaction: Transaction = {
      ...currentTransaction,
      status: "REVIEWED"
    };
    yield put(dataUpdated(DataType.Transaction, [updatedTransaction]));
  }
}

export default function* onSaveSaga() {
  yield takeLatest("crud/update/updateItemSuccess", updateStatusOnSave);
}
